import { render, staticRenderFns } from "./general-node.vue?vue&type=template&id=46665178&scoped=true"
import script from "./general-node.vue?vue&type=script&lang=js"
export * from "./general-node.vue?vue&type=script&lang=js"
import style0 from "./general-node.vue?vue&type=style&index=0&id=46665178&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46665178",
  null
  
)

export default component.exports